






































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListPositions } from '@/components/config'

// services
import { PositionService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// models
import { FormPosition, Position } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditPosition from './modalCreateEdit.vue'

const newItem: FormPosition = {
  name: '',
  description: '',
  is_active: true
}

@Component({
  name: 'PositionsIndex',
  components: {
    PageHeader,
    TableListPositions,
    ModalCreateEditPosition
  }
})
export default class PositionsIndex extends Vue {
  showModal = false
  position: FormPosition = newItem
  title = 'Cargos'
  actionForm = 'save'
  idItemEdit: number|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Cargos',
      active: true
    }
  ]

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.position = newItem
    this.showModal = true
  }

  editItem (position: Position) {
    this.position = {
      name: position.name,
      description: position.description,
      is_active: position.is_active
    }
    if (position.id) {
      this.idItemEdit = Number(position.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (position: Position) {
    const msg = `Seguro que desea eliminar el cargo: ${position.name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && position.id) {
      loading('show')
      await PositionService.delete(position.id)
      alerts.success()
      this.tableList.getPositionsWithPagination()
      loading('hide')
    }
  }

  async changeStatus (infoPosition: {id: number; status: boolean}) {
    loading('show')
    try {
      await PositionService.changeStatus(infoPosition.id, infoPosition.status)
      alerts.success()
      this.tableList.getPositionsWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  get tableList (): Vue & { getPositionsWithPagination: () => void } {
    return this.$refs.table_position as Vue & { getPositionsWithPagination: () => void }
  }

  get itemInit (): FormPosition {
      return newItem
  }
}
